export default __webpack_public_path__ + "static/media/drilllogo.429300d6.png";